export default __webpack_public_path__ + "static/media/scherhaftigkeit-des-dentin.4433937a.svg";